import { createSlice } from "@reduxjs/toolkit";
import { fetchLegalRankTableColumnNames, fetchLegalRank, addLegalRank, updateLegalRank, deleteLegalRank, activateDeactivateLegalRank } from "../thunks";

const initialState = {
  legalRank: [],
  tableColumnNames: [],
  loading: false,
  error: null,
};

const LegalRankSlice = createSlice({
  name: "LegalRank",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    // Fetch Human Categories Table Column Names
    .addCase(fetchLegalRankTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchLegalRankTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
    })
    .addCase(fetchLegalRankTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(fetchLegalRank.pending, (state) => {
        state.loading = true;
        state.error = null;
    })
    .addCase(fetchLegalRank.fulfilled, (state, action) => {
        state.loading = false;
        state.legalRank = action.payload;
    })
    .addCase(fetchLegalRank.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    .addCase(addLegalRank.pending, (state) => {
        state.error = null;
    })
    .addCase(addLegalRank.fulfilled, (state, action) => {
        state.legalRank.unshift(action.payload);
    })
    .addCase(addLegalRank.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(updateLegalRank.pending, (state) => {
        state.error = null;
    })
    .addCase(updateLegalRank.fulfilled, (state, action) => {
        const index = state.legalRank.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.legalRank[index] = action.payload;
        }
    })
    .addCase(updateLegalRank.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(deleteLegalRank.pending, (state) => {
        state.error = null;
    })
    .addCase(deleteLegalRank.fulfilled, (state, action) => {
        state.legalRank = state.legalRank.filter(
            (item) => item.ID !== action.payload[0].ID
        );
    })
    .addCase(deleteLegalRank.rejected, (state, action) => {
        state.error = action.payload;
    })

    .addCase(activateDeactivateLegalRank.pending, (state) => {
        state.error = null;
    })
    .addCase(activateDeactivateLegalRank.fulfilled, (state, action) => {
        const index = state.legalRank.findIndex(
            (item) => item.ID === action.payload.ID
        );
        if (index !== -1) {
            state.legalRank[index] = action.payload;
        }
    })
    .addCase(activateDeactivateLegalRank.rejected, (state, action) => {
        state.error = action.payload;
    })
  },
});

export default LegalRankSlice.reducer;
